import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    // Match pre–star-rating dialog: vertical padding only (dialog content supplies horizontal)
    padding: `${theme.new.spacing.small} 0`,
    width: '100%',
    boxSizing: 'border-box',
  },
  formFieldsBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.small,
    width: '100%',
  },
  /** "How would you rate your experience?" */
  ratingLabel: {
    display: 'block',
    ...theme.typography.label_medium,
    color: theme.new.color.text.secondary,
    marginBottom: theme.new.spacing.xsmall,
  },
  ratingRow: {
    // spacing between stars in FeedbackStarRating (gap) — container only
  },
  formFieldsBlockInner: {
    display: 'flex',
    flexDirection: 'column',
    // Extra space between star row and "Comments" label
    gap: theme.new.spacing.medium,
  },
  messageLabel: {
    display: 'block',
    ...theme.typography.label_medium,
    color: theme.new.color.text.secondary,
    marginBottom: theme.new.spacing.xsmall,
  },
  outlinedMessageField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.new.shape.borderRadius.small,
      backgroundColor: 'rgba(12, 17, 20, 0.02)',
    },
    '& .MuiOutlinedInput-input': {
      padding: 0,
    },
    '& .MuiOutlinedInput-inputMultiline': {
      padding: 0,
    },
    '& textarea': {
      resize: 'vertical',
      padding: 0,
    },
  },
  supportDisclaimer: {
    ...theme.typography.small_body_regular,
    color: theme.new.color.text.primary,
    marginTop: theme.new.spacing.xsmall,
    marginBottom: 0,
  },
  supportLink: {
    color: theme.new.color.brandPrimary,
    fontWeight: 400,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export default useStyles;
